import React, { useEffect } from "react";
import {BrowserRouter,HashRouter, Routes,Route} from 'react-router-dom';


import Home from './layout/Home';
import About from './layout/About';
import Portfolio from './layout/Portfolio';
import Careers from './layout/Careers';
import Contact from './layout/Contact';
import Hireus from './layout/Hireus';
import TermsofServices from './layout/TermsofServices';
import PrivacyPolicy from './layout/PrivacyPolicy';

import BrandDesigning from './layout/BrandDesigning';
import WebDevelopment from './layout/WebDevelopment';
import AppDevelopment from './layout/AppDevelopment';
import DigitalMarketing from './layout/DigitalMarketing';
import Webhosting from './layout/Webhosting';

import ReactGA from "react-ga4";

const TRACKING_ID = "G-1M6BK0BLF0"; // Replace with your GA4 Measurement ID

function App() {

  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
    ReactGA.send("pageview"); // Tracks initial page load
  }, []);
  return (
    <>
    {/* <HashRouter> */}
    <BrowserRouter>
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/about' element={<About />} />
          <Route exact path='/portfolio' element={<Portfolio />} />
          <Route exact path='/careers' element={<Careers />} />          
          <Route exact path='/contact-us' element={<Contact />} />
          <Route exact path='/hire-us' element={<Hireus />} />

          <Route exact path='/terms-of-services' element={<TermsofServices  />} />
          <Route exact path='/privacy-policy' element={<PrivacyPolicy  />} />

          <Route exact path='/services/brand-designing' element={<BrandDesigning  />} />
          <Route exact path='/services/web-development' element={<WebDevelopment  />} />
          <Route exact path='/services/app-development' element={<AppDevelopment  />} />
          <Route exact path='/services/digital-marketing' element={<DigitalMarketing  />} />

          <Route exact path='/services/webhosting' element={<Webhosting />} />
          
        </Routes>
    {/* </HashRouter> */}
    </BrowserRouter>
    </>   
  );
}

export default App;
